import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/GuestSlice';

const selectDomain = (state: RootState) => state?.guest || initialState;

export const selectMessage = createSelector([selectDomain], (state) => state.message);
export const selectSearchResult = createSelector([selectDomain], (state) => state.searchResult);
export const selectStatus = createSelector([selectDomain], (state) => state.status);
export const selectBookADemoURL = createSelector([selectDomain], (state) => state.bookADemoURL);
export const selectLoginResp = createSelector([selectDomain], (state) => state.loginResp);
export const selectPopUpResponse = createSelector([selectDomain], (state) => state.popUpResponse);
export const selectGuestLoading = createSelector([selectDomain], (state) => state.loading);
